import { connect } from "react-redux";
import ApprovalRmTickets from "./approvalRmTickets";
import { bindActionCreators } from "redux";
import {fetchRmTicket, postUpdateRMStatus, getRmTicketsFilterDropDown} from "services/redux/maintenance/rmTicket/action";
const mapStateToProps = (state) => ({
    rmTicket: state.rmTicketReducer.rmTicket,
    rmTicketFilter: state.rmTicketReducer.rmTicketFilter

});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        fetchRmTicket,
        postUpdateRMStatus,
        getRmTicketsFilterDropDown
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ApprovalRmTickets);
